import { render, staticRenderFns } from "./MovementsStock.vue?vue&type=template&id=19cb130e&"
import script from "./MovementsStock.vue?vue&type=script&lang=js&"
export * from "./MovementsStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports